import { FractalSDKContext } from "../context/fractal-sdk-context.js";
import { sdkApiClient } from "../core/api/client.js";
import { storeIdAndTokenInLS } from "../core/token.js";
import { useCallback, useContext } from 'react';
export const useUserSetter = () => {
    const { setUser, setUserWallet } = useContext(FractalSDKContext);
    const fetchAndSetUser = useCallback(async (baseUser, accessToken) => {
        storeIdAndTokenInLS({
            accessToken,
            userId: baseUser.userId,
        });
        const { data } = await sdkApiClient.v1.getInfo();
        const user = {
            ...baseUser,
            email: data.email,
            username: data.username,
        };
        const userWallet = {
            solanaPublicKeys: data.accountPublicKey ? [data.accountPublicKey] : [],
        };
        setUser(user);
        setUserWallet(userWallet);
        return {
            user,
            userWallet,
        };
    }, [setUser, setUserWallet]);
    return {
        fetchAndSetUser,
    };
};
//# sourceMappingURL=use-user-setter.js.map